export default __webpack_public_path__ + "static/Toyota_Desktop_Typography_Legal_Leading-fae716dd39957d76c4ce6b5c0752a30e.svg";